import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioForm';
import FormEntrada from './controlePatioEntradaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';
import Cookies from 'js-cookie';
import Excel from '../common/excel/excel';
import ConfirmModal from '../common/modal/confirmModal';

import {
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getLista,
	getListaMotorista, getListaPlaca, getListaLogs, gerarPdfFicha
} from './controlePatioActions';
import {
	getLista as getListaSetor
} from '../setor/setorActions';
import pendencia from '../pendencia/pendencia';

const columns = [{
	field: 'id',
	type: 'int'
}, {
	field: 'nome_status',
	type: 'text'
}, {
	field: 'cavalo',
	type: 'text'
}, {
	field: 'carreta1',
	type: 'text'
}, {
	field: 'carreta2',
	type: 'text'
}, {
	field: 'nome_motorista',
	type: 'text'
}, {
	field: 'datahora_previsao_chegada',
	type: 'date'
}, {
	field: 'datahora_entrada',
	type: 'date'
}, {
	field: 'datahora_previsao_saida',
	type: 'date'
}, {
	field: 'lote_crt_saida',
	type: 'text'
}, {
	field: 'carga_classificada_saida',
	type: 'text'
}, {
	field: 'expresso_saida',
	type: 'text'
}, {
	field: 'localizacao',
	type: 'text'
}, {
	field: 'shipping_saida',
	type: 'int'
}, {
	field: 'cliente_saida',
	type: 'text'
}, {
	field: 'rumo_saida',
	type: 'text'
}, {
	field: 'fronteira_saida',
	type: 'text'
}, {
	field: 'destino_saida',
	type: 'text'
}, {
	field: 'minutos_patio',
	type: 'int'
}, {
	field: 'minutos_liberado_setores',
	type: 'int'
}, {
	field: 'fichas',
	type: 'text'
}];

const COOKIE_FILTROS = 'controlePatioFiltros';
const COOKIE_ORDENACAO_STATUS = 'controlePatioOrdenacaoStatus';
const COOKIE_SORT = 'controlePatioSort';

class ControlePatio extends Component {

	state = {
		linhaSelecionada: null,
		sort: JSON.parse(
			Cookies.get(COOKIE_SORT)
			||
			JSON.stringify({
				field: 'id',
				direction: 'asc'
			})
		),
		statusVisiveis: JSON.parse(Cookies.get('controlePatioControleStatusVisiveis') || '[1, 2, 3]'),
		ordenacaoStatus: JSON.parse(
			Cookies.get(COOKIE_ORDENACAO_STATUS)
			||
			JSON.stringify({
				1: {
					campo: 'datahora_previsao_entrada',
					direcao: 'asc'
				},
				2: {
					campo: 'datahora_previsao_saida',
					direcao: 'asc'
				},
				3: {
					campo: 'datahora_previsao_saida',
					direcao: 'asc'
				}
			})
		),
		statusOrdenacaoAberta: null
	}

	constructor(props) {
		super(props)

		this.scrollRefs = {};
		this.scrollIntervals = {};
		this.ordenacaoRefs = {};
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
		document.addEventListener('mousedown', this.fecharOrdenacaoClickFora);
		document.addEventListener('keydown', this.fecharOrdenacaoEsc);
	}

	componentWillMount() {

		const filtroCache = Cookies.get(COOKIE_FILTROS);

		if (filtroCache) {

			try {

				this.props.setFiltro(
					JSON.parse(filtroCache)
				);

			} catch (erro) {

				console.log(
					'Erro ao recuperar filtros do Controle de Pátio',
					erro
				);

			}

		}

		this.props.setModoTela('lista');
		this.props.getLista(true);
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaSetor();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
	}

	componentDidUpdate() {
		const telaStatus = (window.location.href || '').includes('controlePatioStatus');

		const modoExibicao =
			telaStatus
			|| this.props.filtro.compacto;

		if (modoExibicao) {

			Object.keys(this.scrollRefs).forEach(id => {

				if (!this.scrollIntervals[id]) {
					this.startAutoScroll(id);
				}

			});

		} else {

			Object.values(this.scrollIntervals).forEach(interval =>
				clearInterval(interval)
			);

			this.scrollIntervals = {};

		}
	}

	componentWillUnmount() {
		Object.values(this.scrollIntervals).forEach(interval =>
			clearInterval(interval)
		);

		clearInterval(this.idIntervalAtualizacao);

		document.removeEventListener('keydown', this.handleKeyDown);
		document.removeEventListener('mousedown', this.fecharOrdenacaoClickFora);
		document.removeEventListener('keydown', this.fecharOrdenacaoEsc);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setFichas(null);
		}
	};

	fecharOrdenacaoClickFora = event => {

		const idStatus = this.state.statusOrdenacaoAberta;

		if (!idStatus) {
			return;
		}

		const ref = this.ordenacaoRefs[idStatus];

		if (
			ref &&
			!ref.contains(event.target)
		) {
			this.setState({
				statusOrdenacaoAberta: null
			});
		}

	}

	fecharOrdenacaoEsc = event => {

		if (
			event.key === 'Escape' &&
			this.state.statusOrdenacaoAberta
		) {
			this.setState({
				statusOrdenacaoAberta: null
			});
		}

	}

	controleFavoritos(idStatus) {
		let lista = JSON.parse(Cookies.get('controlePatioControleStatusVisiveis') || '[1, 2, 3]');

		if (this.state.statusVisiveis.includes(idStatus)) {
			lista = lista.filter(item => item != idStatus);
		} else {
			lista.push(idStatus);
		}
		this.setState({ statusVisiveis: lista });

		Cookies.set('controlePatioControleStatusVisiveis', JSON.stringify(lista), { expires: 15 });
	}

	render() {
		return (
			<div>

				{this.state.confirmacao &&
				<ConfirmModal
					visible={this.state.confirmacao}
					titulo='Confirmação'
					mensagem={this.state.confirmacao.mensagem}
					textoConfirmar='Sim'
					textoCancelar='Cancelar'
					onConfirm={this.state.confirmacao.eventoSim}
					onCancel={this.state.confirmacao.eventoCancelar}
				/>}

				<Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'entrada' ? (
						<FormEntrada onSubmit={(registro) => this.props.salvarEntrada(registro)} />
					) : null}
					{this.props.modoTela == 'saida' ? (
						<Form onSubmit={(registro) => this.props.salvarSaida(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.dados() : null}
				</Content>
			</div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.cavalo}
						${item.carreta1 || ''}
						${item.carreta2 || ''}
						${item.lote_crt_saida ? 'Lote' : ''}
						${item.carga_classificada_saida ? 'Classificada' : ''}
						${item.expresso_saida ? 'Expressa' : ''}
						${item.nome_motorista}
						${item.id_status == 1 ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada) : ''}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}
						
						${item.id_status == 1 ? item.localizacao : ''} //Aguardando Entrada			
						${item.shipping_saida}
						${item.cliente_saida}
						${item.rumo_saida}						
						${item.rumo_saida == 'RS' ? item.fronteira_saida : item.destino_saida}
						${item.cliente_saida}
					`.toUpperCase().includes(pesquisar.trim())
					);
		}).filter(item => {

			//Aguardando entrada
			if (item.id_status == 1) {

				//Se marcos o todos ignora os demais filtros
				if (this.props.filtro.todos_aguardando_entrada) {
					return true;
				}
				//Reingresso - Apenas lista quando marca o todos
				if (item.passou_patio) {
					return false;
				}
				//Passa na Matriz
				if (this.props.filtro.passa_na_matriz && item.passa_patio) {
					return true;
				}
				//Deslocamento
				if (this.props.filtro.deslocamento_patio && item.deslocamento_patio) {
					return true;
				}
				//Vazios
				if (!this.props.filtro.reingresso && !this.props.filtro.passa_na_matriz && !this.props.filtro.deslocamento_patio
					&& !item.shipping_entrada) {
					return true;
				}
				
				return false;
			}

			return true;
		});

		if (this.props.filtro.modoLista) {
			return sortData(
				listaFiltrada,
				this.state.sort,
				columns
			);
		} else {
			return listaFiltrada;
		}
	}

	onSort(field) {

		this.setState(prev => {

			let direction = 'asc';

			if (prev.sort.field === field) {
				direction =
					prev.sort.direction === 'asc'
						? 'desc'
						: 'asc';
			}

			const sort = {
				field,
				direction
			};

			Cookies.set(
				COOKIE_SORT,
				JSON.stringify(sort),
				{
					expires: 30
				}
			);

			return {
				sort
			};

		});

	}

	startAutoScroll(id) {

		const container =
			this.scrollRefs[id]
				? this.scrollRefs[id].current
				: null;

		if (!container) {
			return;
		}

		if (container.scrollHeight <= container.clientHeight) {
			return;
		}

		let direction = 1;
		let pausado = false;

		const speed = 1;
		const delayAtEnd = 5000;

		this.scrollIntervals[id] = setInterval(() => {

			if (pausado) {
				return;
			}

			container.scrollTop += speed * direction;

			const chegouFim =
				container.scrollTop + container.clientHeight
				>= container.scrollHeight - 5;

			const chegouInicio = container.scrollTop <= 0;

			if (chegouFim && direction === 1) {

				pausado = true;

				setTimeout(() => {
					direction = -1;
					pausado = false;
				}, delayAtEnd);

			}

			if (chegouInicio && direction === -1) {

				pausado = true;

				setTimeout(() => {
					direction = 1;
					pausado = false;
				}, delayAtEnd);

			}

		}, 20);

	}

	setFiltroCache(filtro) {

		this.props.setFiltro(filtro);

		Cookies.set(
			COOKIE_FILTROS,
			JSON.stringify(filtro),
			{
				expires: 30
			}
		);

	}

	dados() {

		let lista = this.filtrar();

	const telaStatus =
		(window.location.href || '').includes('controlePatioStatus');

	const modoExibicao =
		telaStatus
		|| this.props.filtro.compacto;


	const heightTela = modoExibicao
		? `${window.innerHeight - 55}px`
		: (
			window.innerWidth < 685
				? `${window.innerHeight - 290}px`
				: `${window.innerHeight - 200}px`
		);


	return (
		<div
			style={
				this.props.filtro.compacto
					? {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						width: '100vw',
						height: '100vh',
						zIndex: 9999,
						backgroundColor: '#ffffff',
						overflow: 'hidden',
						padding: 6
					}
					: {}
			}
		>

			<ContentCard>

				{this.registroFicha()}

				<div
					className='card-body'
					style={{
						padding: this.props.filtro.compacto ? 2 : 8,
						paddingBottom: 0
					}}
				>
					{(!telaStatus && !this.props.filtro.compacto) &&
						<Row>
							<InputPesquisa
								maxWidth={345}
								minWidth={345}
								cols='12 12 12 12'
								label='Pesquisar'
								value={this.props.filtro.pesquisar}
								onChange={value => this.setFiltroCache({ ...this.props.filtro, pesquisar: value })} />

							<Select
								options={this.props.listaRumo}
								label='Rumo'
								cols='12 1 1 1'
								minWidth={110}
								placeholder='Selecione'
								value={this.props.filtro.id_rumo}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										id_rumo: value
									});
								}} />

							<Select
								options={this.props.listaAtraso}
								label='Atraso'
								cols='12 1 1 1'
								minWidth={150}
								placeholder='Selecione'
								value={this.props.filtro.id_atraso}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										id_atraso: value
									});
								}} />

							<Select
								options={[{ id: 1, valor : 'Sim' }, { id: 2, valor : 'Não' }, { id: 3, valor : 'Ambas' }]}
								label='Com Prev. Saída'
								cols='12 1 1 1'
								minWidth={140}
								placeholder='Selecione'
								naoLimpar
								value={this.props.filtro.com_previsao_saida && this.props.filtro.sem_previsao_saida ? 3 : (this.props.filtro.com_previsao_saida ? 1 : 2)}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										com_previsao_saida: value == 1 || value == 3,
										sem_previsao_saida: value == 2 || value == 3
									});
								}} />

							<Select
								options={[{ id: 1, valor : 'Sim' }, { id: 2, valor : 'Não' }, { id: 3, valor : 'Ambas' }]}
								label='Ficha Impressa'
								cols='12 1 1 1'
								minWidth={130}
								placeholder='Selecione'
								naoLimpar
								value={this.props.filtro.impresso && this.props.filtro.nao_impresso ? 3 : (this.props.filtro.impresso ? 1 : 2)}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										impresso: value == 1 || value == 3,
										nao_impresso: value == 2 || value == 3
									});
								}} />

							<LabelAndInputDate
								label='Previsão Chegada'
								cols='12 6 4 4'
								value={this.props.filtro.data_previsao_chegada}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										data_previsao_chegada: value
									});
								}} />

							<LabelAndInputDate
								label='Previsão Saída'
								cols='12 6 4 4'
								value={this.props.filtro.data_previsao_saida}
								onChange={value => {
									this.setFiltroCache({
										...this.props.filtro,
										data_previsao_saida: value
									});
								}} />

							<div style={{ width: 90, paddingTop: 4 }}>
								{this.props.listaStatus.map(status => {

									const statusVisivel = this.state.statusVisiveis.includes(status.id);

									return (
										<div class={`filter-chip ${statusVisivel ? 'active' : ''}`}
											style={{
												margin: 0,
												borderRadius: 4,
												width: '100%',
												justifyContent: 'center',
												fontSize: 9,
												paddingTop: 1,
												paddingBottom: 1
											}}
											onClick={() => {
												this.controleFavoritos(status.id);
											}}>
											{status.nome.replace('Aguardando', 'Aguard.')}
										</div>
									);
								})}
							</div>

							<div
								style={{
									display: 'flex',
									alignItems: 'flex-start',
									marginTop: 8,
									marginLeft: 8
								}} >
								<a
									class='btn btn-app bg-primary'
									style={{
										margin: 0,
										marginRight: 4,
										minWidth: 75
									}}
									onClick={() => {
										this.props.getLista(true);
									}}
								>
									<i class='fas fa-sync-alt'></i>
									Atualizar
								</a>

								<div
									style={{
										width: 32,
										display: 'flex',
										flexDirection: 'column',
										gap: 2,
										paddingTop: 1
									}}
								>
									{/* Compacto / Expandido */}
									<div
										class='bg-secondary'
										style={{
											width: 32,
											height: 28,
											borderRadius: 4,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											cursor: 'pointer'
										}}
										onClick={() => {
											this.setFiltroCache({
												...this.props.filtro,
												compacto: true,
												modoLista: false
											});
										}}
										title='Modo de Exibição'
									>
										<i
											class={'fas fa-tv'}
										></i>
									</div>

									{/* Cards / Lista */}
									<div
										class='bg-secondary'
										style={{
											width: 32,
											height: 28,
											borderRadius: 4,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											cursor: 'pointer'
										}}
										onClick={() => {
											this.setFiltroCache({
												...this.props.filtro,
												modoLista: !this.props.filtro.modoLista
											});
										}}
										title={
											this.props.filtro.modoLista
												? 'Cards'
												: 'Lista'
										}
									>
										<i
											class={
												this.props.filtro.modoLista
													? 'fas fa-th'
													: 'fas fa-table'
											}
										></i>
									</div>
								</div>
							</div>
						</Row>}

						{this.props.filtro.compacto &&
						<div
							style={{
								position: 'fixed',
								top: 8,
								right: 8,
								zIndex: 10001
							}}
						>
							<button
								type='button'
								class='btn btn-secondary'
								title='Sair do modo de exibição'
								style={{
									width: 44,
									height: 44,
									padding: 0,
									borderRadius: 6,
									boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
								}}
								onClick={() => {

									this.setFiltroCache({
										...this.props.filtro,
										compacto: false
									});

								}}
							>
								<i class='fas fa-expand'></i>
							</button>
						</div>}

						{this.props.filtro.compacto
							? this.cards(lista, heightTela)
							: (
								this.props.filtro.modoLista
									? this.lista(lista, heightTela)
									: this.cards(lista, heightTela)
							)
						}

					</div>
				</ContentCard>
			</div>
		);
	}

	clickCardLista(item) {

		if (item.id_status == 1) { //Aguardando Entrada
			this.props.setModoTela('entrada', {
				...item
			});
			this.props.getListaLogs(item.id);
			
			this.props.initForm({
				...item,
				datahora_entrada: item.datahora_entrada || DateFormat.getDataHoraAtual(),
				//Se já tem data e hora de entrada já mostra é porque só falta assinatura
				registrosEntradaConfirmados: !!item.datahora_entrada,
				registrosAguardandoEntrada: !!item.datahora_entrada
			});
		} else if (item.id_status == 2) { //No Pátio
			this.props.setModoTela('saida', {
				...item
			});
			this.props.getListaLogs(item.id);
			this.props.initForm({
				...item,
				cavalo_base: item.cavalo,
				carreta1_base: item.carreta1,
				carreta2_base: item.carreta2,
				id_motorista_base: item.id_motorista
			});
		} else if (item.id_status == 3) { //Aguardando Saída
			this.props.setModoTela('saida', {
				...item
			});
			this.props.getListaLogs(item.id);
			this.props.initForm({
				...item,
				cavalo_base: item.cavalo,
				carreta1_base: item.carreta1,
				carreta2_base: item.carreta2,
				id_motorista_base: item.id_motorista
			});
		}

	}

	montarBadges(item, align) {

		if (item.id_status == 2) {
			// No Pátio

			return (
				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: align }}>
					{item.fichas_setores.map(ficha => {
						let cor = null;
						if (ficha.quantidade == ficha.executadas) {
							cor = '#087d00';
						} else if (ficha.obrigatoria) {
							cor = ficha.iniciada ? '#0085b5' : '#949191';
						} else {
							cor = ficha.iniciada ? '#0085b5' : '#949191';
						}

						return (
							<div key={ficha.id_setor}
								className='card-badge-patio'
								style={{
									backgroundColor: cor,
									color: '#ffffff',
									paddingLeft: 4,
									paddingRight: 4,
									marginRight: 2,
									marginTop: 1,
									marginBottom: 1,
									borderRadius: 2,
									display: 'inline-block'
								}}
								title={ficha.nome}
								onMouseDown={(event) => {
									event.stopPropagation();
								}}
								onMouseUp={(event) => {
									event.stopPropagation();
								}}
								onClick={event => {
									event.stopPropagation();

									let listaPendencias = [];
									let listaFichas = [];

									if ([5, 6, 999].includes(ficha.id_setor) || [5, 6, 999].includes(ficha.id_setor_pai)) {
										//Pendência
										listaPendencias = [...item.listaPendenciaMotorista, ...item.listaPendenciaDemais].map(pendencia => ({
											id: pendencia.id,
											nome_setor: pendencia.nome_setor,
											nome: pendencia.nome_motorista || pendencia.cavalo || pendencia.carreta || pendencia.shipping,
											nome_status: pendencia.nome_status,
											nome_tipo: pendencia.nome_tipo,
											observacao: pendencia.observacao,
											bloqueia_saida: pendencia.bloqueia_saida,
											data_maxima: pendencia.data_maxima,
											resolvida: pendencia.resolvida,
											cor: pendencia.resolvida ? '#087d00' : (
												pendencia.bloqueia_saida ? '#b80300' : '#ff5e00'
											)
										}))
									} else {
										//Ficha
										listaFichas = (item.fichas_setores_completa || []).filter(itemFicha => itemFicha && itemFicha.id_setor == ficha.id_setor).map(itemFicha => ({
											id: itemFicha.id,
											id_controle_patio_ficha: itemFicha.id_controle_patio_ficha,
											nome: ficha.nome_motorista || itemFicha.cavalo || itemFicha.carreta,
											datahora_fim: itemFicha.datahora_fim,
											datahora_inicio: itemFicha.datahora_inicio,
											datahora_liberacao: itemFicha.datahora_liberacao,
											obrigatoria: itemFicha.obrigatoria,
											cor: itemFicha.datahora_liberacao || itemFicha.datahora_fim ? '#087d00' : (
												itemFicha.obrigatoria ? '#b80300' : '#ff5e00'
											),
											lista_eventos: itemFicha.lista_eventos
										}))
									}

									if (this.state.registroFicha && this.state.registroFicha.id == ficha.id) {
										this.setFichas(null);
									} else {
										let cor = null;
										if (ficha.quantidade == ficha.executadas) {
											cor = '#087d00';
										} else if (ficha.obrigatoria) {
											cor = '#b80300';
										} else {
											cor = '#ff5e00';
										}

										this.setFichas({
											id: ficha.id,
											icone: ficha.icone,
											cavalo: item.cavalo,
											cor: cor,
											nome: ficha.nome,
											listaPendencias: listaPendencias.length ? listaPendencias : null,
											listaFichas: listaFichas.length ? listaFichas : null,
											listaManutencoes: ficha.id_setor == 3 ? (item.lista_manutencao || []).filter(manutencao => manutencao) : [] //Oficina 
										});
									}
								}}>
								<i class={ficha.icone} style={{ marginRight: 4 }}></i>
								{ficha.quantidade == ficha.executadas ? 'OK' : `${ficha.executadas} de ${ficha.quantidade}`}
							</div>
						);
					})}
				</div>
			);
		} else if (item.id_status == 3) {
			// Aguardando Saída

			return (
				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: align }}>
					{item.listaPendenciaMotorista.map(ficha => {
						let cor = null;
						if (ficha.bloqueia_saida) {
							cor = '#949191';
						} else {
							cor = '#949191';
						}

						return (
							<div key={ficha.id_setor}
								className='card-badge-patio'
								style={{
									backgroundColor: cor,
									color: '#ffffff',
									paddingLeft: 4,
									paddingRight: 4,
									marginRight: 2,
									marginTop: 1,
									marginBottom: 1,
									borderRadius: 2,
									fontWeight: 'bold',
									display: 'inline-block'
								}}
								title={ficha.nome_setor}
								onMouseDown={(event) => {
									event.stopPropagation();
								}}
								onMouseUp={(event) => {
									event.stopPropagation();
								}}
								onClick={event => {
									event.stopPropagation();

									let listaPendencias = item.listaPendenciaMotorista.filter(pendencia => ficha.id_setor == pendencia.id_setor).map(pendencia => ({
										id: pendencia.id,
										nome_setor: pendencia.nome_setor,
										nome: pendencia.nome_motorista || pendencia.cavalo || pendencia.carreta || pendencia.shipping,
										nome_status: pendencia.nome_status,
										nome_tipo: pendencia.nome_tipo,
										observacao: pendencia.observacao,
										bloqueia_saida: pendencia.bloqueia_saida,
										data_maxima: pendencia.data_maxima,
										resolvida: pendencia.resolvida,
										cor: pendencia.resolvida ? '#087d00' : (
											pendencia.bloqueia_saida ? '#b80300' : '#ff5e00'
										)
									}));

									if (this.state.registroFicha && this.state.registroFicha.id == ficha.id) {
										this.setFichas(null);
									} else {
										let cor = null;
										if (ficha.quantidade == ficha.executadas) {
											cor = '#087d00';
										} else if (ficha.obrigatoria) {
											cor = '#b80300';
										} else {
											cor = '#ff5e00';
										}

										this.setFichas({
											id: ficha.id,
											icone: ficha.icone,
											cavalo: item.cavalo,
											cor: cor,
											nome: ficha.nome_setor,
											listaPendencias: listaPendencias.length ? listaPendencias : null,
											listaFichas: null,
											listaManutencoes: ficha.id_setor == 3 ? (item.lista_manutencao || []).filter(manutencao => manutencao) : [] //Oficina 
										});
									}
								}}>
								{ficha.abreviacao_setor || ficha.nome_setor}
							</div>
						);
					})}
				</div>
			);
		} else {
			return null;
		}
	}

	getOpcoesOrdenacaoStatus(status) {

		let opcoes = [];

		/*
		* AGUARDANDO ENTRADA
		*/
		if (status.id == 1) {

			opcoes.push(
				{
					campo: 'datahora_previsao_entrada',
					nome: 'Previsão de Chegada',
					tipo: 'data'
				}
			);

		}

		opcoes.push(
			{
				campo: 'datahora_previsao_saida',
				nome: 'Previsão de Saída',
				tipo: 'data'
			},
			{
				campo: 'cavalo',
				nome: 'Cavalo',
				tipo: 'texto'
			},
			{
				campo: 'carreta1',
				nome: 'Carreta 1',
				tipo: 'texto'
			},
			{
				campo: 'carreta2',
				nome: 'Carreta 2',
				tipo: 'texto'
			},
			{
				campo: 'nome_motorista',
				nome: 'Motorista',
				tipo: 'texto'
			},
			{
				campo: 'shipping_saida',
				nome: 'Shipping',
				tipo: 'texto'
			},
			{
				campo: 'cliente_saida',
				nome: 'Cliente',
				tipo: 'texto'
			},
			{
				campo: 'rumo_saida',
				nome: 'Rumo',
				tipo: 'texto'
			},
			{
				campo: 'fronteira_saida',
				nome: 'Fronteira',
				tipo: 'texto'
			},
			{
				campo: 'destino_saida',
				nome: 'Destino',
				tipo: 'texto'
			},
			{
				campo: 'lote_crt_saida',
				nome: 'Lote',
				tipo: 'texto'
			},
			{
				campo: 'carga_classificada_saida',
				nome: 'Carga Classificada',
				tipo: 'boolean'
			},
			{
				campo: 'expresso_saida',
				nome: 'Carga Expressa',
				tipo: 'boolean'
			}
		);

		/*
		* AGUARDANDO ENTRADA
		*/
		if (status.id == 1) {

			opcoes.push(
				{
					campo: 'localizacao',
					nome: 'Localização',
					tipo: 'texto'
				}
			);

		}

		/*
		* NO PÁTIO / AGUARDANDO SAÍDA
		*/
		if (
			status.id == 2 ||
			status.id == 3
		) {

			opcoes.push({
				campo: 'minutos_patio',
				nome: 'Tempo no Pátio',
				tipo: 'numero'
			});

		}

		/*
		* AGUARDANDO SAÍDA
		*/
		if (status.id == 3) {

			opcoes.push({
				campo: 'minutos_liberado_setores',
				nome: 'Tempo Liberado',
				tipo: 'numero'
			});

		}

		return opcoes;
	}

	getOrdenacaoStatus(idStatus) {

		return (
			(this.state.ordenacaoStatus || {})[idStatus]
			||
			null
		);
	}


	setOrdenacaoStatus(idStatus, campo, direcao) {

		const ordenacaoStatus = {
			...(this.state.ordenacaoStatus || {}),

			[idStatus]: {
				campo,
				direcao
			}
		};

		this.setState({
			ordenacaoStatus
		});

		Cookies.set(
			COOKIE_ORDENACAO_STATUS,
			JSON.stringify(ordenacaoStatus),
			{
				expires: 30
			}
		);

	}


	limparOrdenacaoStatus(idStatus) {

		const ordenacaoStatus = {
			...(this.state.ordenacaoStatus || {})
		};

		delete ordenacaoStatus[idStatus];

		this.setState({
			ordenacaoStatus
		});

		Cookies.set(
			COOKIE_ORDENACAO_STATUS,
			JSON.stringify(ordenacaoStatus),
			{
				expires: 30
			}
		);

	}

	ordenarListaStatus(lista, status) {

		const ordenacao =
			this.getOrdenacaoStatus(
				status.id
			);

		if (
			!ordenacao ||
			!ordenacao.campo
		) {
			return lista;
		}

		const opcoes =
			this.getOpcoesOrdenacaoStatus(
				status
			);

		const opcao =
			opcoes.find(item =>
				item.campo == ordenacao.campo
			);

		if (!opcao) {
			return lista;
		}

		const {
			campo,
			direcao
		} = ordenacao;

		const tipo =
			opcao.tipo || 'texto';


		return [...lista].sort((a, b) => {

			let valorA = a[campo];
			let valorB = b[campo];


			/*
			* ======================================
			* NULOS / VAZIOS
			* sempre ficam no final
			* ======================================
			*/

			const vazioA =
				valorA === null ||
				valorA === undefined ||
				valorA === '';

			const vazioB =
				valorB === null ||
				valorB === undefined ||
				valorB === '';


			if (vazioA && vazioB) {
				return 0;
			}

			if (vazioA) {
				return 1;
			}

			if (vazioB) {
				return -1;
			}


			let comparacao = 0;


			/*
			* ======================================
			* NÚMERO
			* ======================================
			*/

			if (tipo == 'numero') {

				valorA =
					parseFloat(valorA) || 0;

				valorB =
					parseFloat(valorB) || 0;

				comparacao =
					valorA - valorB;

			}


			/*
			* ======================================
			* DATA
			* ======================================
			*/

			else if (tipo == 'data') {

				const dataA =
					new Date(valorA)
						.getTime();

				const dataB =
					new Date(valorB)
						.getTime();

				if (
					isNaN(dataA) &&
					isNaN(dataB)
				) {
					comparacao = 0;
				}
				else if (isNaN(dataA)) {
					return 1;
				}
				else if (isNaN(dataB)) {
					return -1;
				}
				else {
					comparacao =
						dataA - dataB;
				}

			}


			/*
			* ======================================
			* BOOLEAN
			* ======================================
			*/

			else if (tipo == 'boolean') {

				const boolA =
					valorA === true ||
					valorA === 'true' ||
					valorA === 1 ||
					valorA === '1';

				const boolB =
					valorB === true ||
					valorB === 'true' ||
					valorB === 1 ||
					valorB === '1';

				comparacao =
					Number(boolA) -
					Number(boolB);

			}


			/*
			* ======================================
			* TEXTO
			* ======================================
			*/

			else {

				comparacao =
					String(valorA)
						.localeCompare(
							String(valorB),
							'pt-BR',
							{
								numeric: true,
								sensitivity: 'base'
							}
						);

			}


			return (
				direcao == 'asc'
					? comparacao
					: comparacao * -1
			);

		});

	}
		
	cards(lista, heightTela) {

		const telaStatus = (window.location.href || '').includes('controlePatioStatus');

		const modoExibicao = telaStatus || this.props.filtro.compacto;

		const usuarioOficina = !!this.props.listaSetor.filter(item => item.id == 3 && ['GESTOR', 'SUPERVISOR', 'USUARIO'].includes(item.permissao)).length; //3 - Oficina

		return (
			<Row>
				{this.props.listaStatus.map(status => {

					if (modoExibicao) {

						if (!this.scrollRefs[status.id]) {
							this.scrollRefs[status.id] = React.createRef();
						}

					}

					if (!this.state.statusVisiveis.includes(status.id)) {
						return null;
					}

					const cols = this.state.statusVisiveis.length == 3 ? '12 12 4 4' : (
						this.state.statusVisiveis.length == 2 ? '12 12 6 6' : '12 12 12 12'
					);

					const ordenacao = this.getOrdenacaoStatus(status.id);

					const opcaoSelecionada =
						this.getOpcoesOrdenacaoStatus(status)
							.find(opcao =>
								ordenacao &&
								opcao.campo == ordenacao.campo
							);

					const listaFiltradaOrdenada = this.ordenarListaStatus(
						lista.filter(item =>
							item.id_status == status.id
						),
						status
					);

					return (
						<Grid key={status.id} cols={cols}>
							<div style={{ height: heightTela, backgroundColor: '#1F3066' }}>
								<Table responsive noHover alturaFixa backgroundColor={'#1F3066'}
									style={{ borderCollapse: 'collapse', border: 'none' }}
									ref={this.scrollRefs[status.id]}
									maxHeight={heightTela}>
									<THead>
										<Tr backgroundColor={'#1F3066'}
											color={'#ffffff'}
											height={47}>
											<ThSort
												field='cavalo'
												label={
													<div
														ref={ref => this.ordenacaoRefs[status.id] = ref}
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															position: 'relative',
															overflow: 'visible'
														}}
													>
														<button
															type='button'
															style={{
																height: 28,
																width: 120,
																padding: '2px 7px',
																fontSize: 9,
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'flex-start',
																gap: 6,
																marginRight: 6,

																backgroundColor: '#1F3066',
																color: '#ffffff',

																border: '1px solid rgba(255,255,255,0.85)',
																borderRadius: 6,

																cursor: 'pointer',
																outline: 'none'
															}}
															title={
																opcaoSelecionada
																	? `Ordenado por ${opcaoSelecionada.nome} - ${
																		ordenacao.direcao == 'asc'
																			? 'Crescente'
																			: 'Decrescente'
																	}`
																	: 'Ordenar'
															}
															onClick={(e) => {

																const rect = e.currentTarget.getBoundingClientRect();

																this.setState({
																	statusOrdenacaoAberta:
																		this.state.statusOrdenacaoAberta == status.id
																			? null
																			: status.id,

																	posicaoOrdenacao: {
																		top: rect.bottom + 4,
																		left: rect.left
																	}
																});

															}}
														>
															<span
																style={{
																	width: 20,
																	height: 20,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	flexShrink: 0,
																	borderRight: '1px solid rgba(255,255,255,0.35)',
																	paddingRight: 6
																}}
															>
																<i
																	class={
																		ordenacao && ordenacao.direcao == 'desc'
																			? 'fas fa-sort-amount-down-alt'
																			: 'fas fa-sort-amount-down'
																	}
																	style={{
																		fontSize: 11,
																		color: '#ffffff'
																	}}
																></i>
															</span>

															<span
																style={{
																	flex: 1,
																	minWidth: 0,
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																	whiteSpace: 'nowrap',
																	textAlign: 'left',
																	fontWeight: 500
																}}
															>
																{opcaoSelecionada
																	? opcaoSelecionada.nome
																	: 'Ordenar'
																}
															</span>
														</button>
														{this.state.statusOrdenacaoAberta == status.id &&
														<div
															ref={ref => this.ordenacaoRefs[status.id] = ref}
															style={{
																position: 'fixed',

																top: this.state.posicaoOrdenacao
																	? this.state.posicaoOrdenacao.top
																	: 0,

																left: this.state.posicaoOrdenacao
																	? this.state.posicaoOrdenacao.left
																	: 0,

																width: 230,
																maxHeight: 420,
																overflowY: 'auto',

																backgroundColor: '#ffffff',
																border: '1px solid #d9d9d9',
																borderRadius: 6,
																boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
																zIndex: 99999,
																padding: 8
															}}
														>
															{this.getOpcoesOrdenacaoStatus(status).map(opcao => {

																const ordenacao = this.getOrdenacaoStatus(status.id);

																const selecionado =
																	ordenacao &&
																	ordenacao.campo == opcao.campo;

																return (
																	<div
																		key={opcao.campo}
																		style={{
																			minHeight: 36,
																			display: 'flex',
																			alignItems: 'center',
																			justifyContent: 'space-between',
																			padding: '5px 6px',
																			borderRadius: 4,
																			backgroundColor:
																				selecionado
																					? '#1F3066'
																					: '#ffffff'
																					
																		}}
																	>
																		<div
																			style={{
																				fontSize: 11,
																				cursor: 'pointer',
																				flex: 1,
																				height: '100%',
																				color:
																					selecionado
																						? '#ffffff'
																						: '#1F3066',
																				textAlign: 'left',
																				fontWeight: 'normal'
																			}}
																			onClick={() => {

																				this.setOrdenacaoStatus(
																					status.id,
																					opcao.campo,
																					ordenacao &&
																					ordenacao.campo == opcao.campo
																						? ordenacao.direcao
																						: 'asc'
																				);

																			}}
																		>
																			{opcao.nome}
																		</div>
																		{(ordenacao && ordenacao.campo == opcao.campo) &&
																		<div
																			style={{
																				display: 'flex',
																				gap: 3
																			}}
																		>
																			<button
																				type='button'
																				class={'btn btn-xs btn-default'}
																				title={ordenacao && ordenacao.campo == opcao.campo && ordenacao.direcao == 'asc' ? 'Crescente' : 'Decrescente'}
																				onClick={() => {

																					this.setOrdenacaoStatus(
																						status.id,
																						opcao.campo,
																						ordenacao && ordenacao.direcao == 'asc' ? 'desc' : 'asc'
																					);

																				}}
																			>
																				<i class={ordenacao && ordenacao.campo == opcao.campo && ordenacao.direcao == 'asc' ? 'fas fa-sort-amount-down-alt' : 'fas fa-sort-amount-down'}></i>
																			</button>
																		</div>}
																	</div>
																);

															})}
														</div>}

														{status.nome}

														<div style={{ width: 120, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: 4 }}>
															{!modoExibicao &&
															<button
																type='button'
																class='btn btn-flat btn-xs btn-success'
																title='Exportar'
																style={{
																	visibility: 'visible',
																	marginLeft: 8,
																	marginLeft: 8,
																	width: 24,
																	height: 24,
																	borderRadius: 4,
																	border: 'none',
																	background: 'linear-gradient(135deg, #16a34a, #22c55e)',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	cursor: 'pointer',
																	boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
																	transition: 'all 0.2s ease'
																}}
																onMouseEnter={e => {
																	e.currentTarget.style.transform = 'scale(1.08)';
																	e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.25)';
																}}
																onMouseLeave={e => {
																	e.currentTarget.style.transform = 'scale(1)';
																	e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
																}}
																onClick={() => {
																	this.gerarExcel(listaFiltradaOrdenada.filter(item => item.id_status == status.id));
																}}>
																<i class='fas fa-file-excel'></i>
															</button>}
															{([2, 3].includes(status.id) && !modoExibicao) &&
															<button
																type='button'
																class='btn btn-flat btn-xs btn-success'
																title='Gerar Ficha'
																style={{
																	visibility: 'visible',
																	marginLeft: 8,
																	marginLeft: 8,
																	width: 24,
																	height: 24,
																	borderRadius: 4,
																	border: 'none',
																	background: 'linear-gradient(135deg, #007bff, #045fc1ff)',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	cursor: 'pointer',
																	boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
																	transition: 'all 0.2s ease'
																}}
																onMouseEnter={e => {
																	e.currentTarget.style.transform = 'scale(1.08)';
																	e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.25)';
																}}
																onMouseLeave={e => {
																	e.currentTarget.style.transform = 'scale(1)';
																	e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
																}}
																onClick={() => {
																	this.setState({
																		confirmacao: {
																			mensagem: 'Deseja realmente imprimir?',
																			eventoSim: () => {
																				this.props.gerarPdfFicha(listaFiltradaOrdenada.filter(item => item.id_status == status.id));
																				this.setState({
																					confirmacao: null
																				});
																			},
																			eventoCancelar: () => {
																				this.setState({
																					confirmacao: null
																				});
																			}
																		}
																	});
																}}>
																<i class='fas fa-file-pdf'></i>
															</button>}
														</div>
													</div>
												}
												width={300}
												sticky />
										</Tr>
									</THead>
									<TBody>
										{listaFiltradaOrdenada.map((item, i) => (
											<tr key={i} style={{ border: 'none' }}>
												<td
													style={{
														border: 'none',
														padding: 4,
														maxWidth: 350,
														width: 350,
														overflow: 'hidden'
													}}>
													<div className='controle-patio-card-hover'
														style={{
															display: 'flex',
															flexDirection: 'row',
															width: '100%',
															maxWidth: '100%',
															overflow: 'hidden',
															backgroundColor: item.atraso == 'atrasado' ? '#fac5c5' : ''
														}}
														onClick={() => {
															if (!modoExibicao) {
																this.clickCardLista(item);
															}

														}}>
														<div style={{
															display: 'flex',
															flexDirection: 'column',
															justifyContent: 'center',
															alignItems: 'center',
															fontSize: 16,
															fontWeight: 'bold',
															width: 120,
															flexShrink: 0
														}}>
															<div>
																{item.cavalo}
															</div>
															{(item.carreta1 || item.carreta2) &&
																<div style={{ fontSize: 9, fontWeight: 'bold' }}>
																	{item.carreta1}
																	{item.carreta1 && item.carreta2 ? ' | ' : ''}
																	{item.carreta2}
																</div>}

															<div style={{
																color: item.atraso == 'atrasado' ? '#b80300' : '',
																fontSize: 10,
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																marginTop: 4
															}}>
																<i class='fas fa-calendar-check' style={{ marginRight: 4 }}></i>
																<div style={{}}><b>Prev. Saída:</b></div>
															</div>
															<div style={{ color: item.atraso == 'atrasado' ? '#b80300' : '', fontSize: 13 }}>
																<div style={{ marginTop: 1 }}>{DateFormat.formatarDataHoraSqlParaTelaDiaMes(item.datahora_previsao_saida)}</div>
															</div>
															{/* <p style={{ padding: 0, margin: 0, fontSize: 8 }}>{item.passa_patio ? 'Passa Matriz' : 'Não Passa Matriz'}</p> 
															<p style={{ padding: 0, margin: 0, fontSize: 8 }}>{item.deslocamento_patio ? 'Em Deslocamento' : 'Sem Deslocamento'}</p>
															<p style={{ padding: 0, margin: 0, fontSize: 8 }}>{item.passou_patio ? 'Reingresso' : 'Não Ingresso'}</p>*/}
															{item.lote_crt_saida &&
																<div
																	style={{
																		backgroundColor: '#1F3066',
																		color: '#ffffff',
																		paddingLeft: 4,
																		paddingRight: 4,
																		marginRight: 2,
																		marginTop: 1,
																		marginBottom: 1,
																		borderRadius: 2,
																		fontSize: 10,
																		fontStyle: 'normal',
																		marginTop: 2
																	}}
																	title={item.lote_crt_saida}>
																	<i class='fas fa-boxes' style={{ marginRight: 4 }}></i>
																	Lote
																</div>}
															{item.carga_classificada_saida &&
																<div
																	style={{
																		backgroundColor: '#1F3066',
																		color: '#ffffff',
																		paddingLeft: 4,
																		paddingRight: 4,
																		marginRight: 2,
																		marginTop: 1,
																		marginBottom: 1,
																		borderRadius: 2,
																		fontSize: 10,
																		fontStyle: 'normal',
																		marginTop: 2
																	}}>
																	<i class='fas fa-exclamation-triangle' style={{ marginRight: 4 }}></i>
																	Classificada
																</div>}
															{item.expresso_saida &&
																<div
																	style={{
																		backgroundColor: '#1F3066',
																		color: '#ffffff',
																		paddingLeft: 4,
																		paddingRight: 4,
																		marginRight: 2,
																		marginTop: 1,
																		marginBottom: 1,
																		borderRadius: 2,
																		fontSize: 10,
																		fontStyle: 'normal',
																		marginTop: 2
																	}}>
																	<i class='fas fa-shipping-fast' style={{ marginRight: 4 }}></i>
																	Expressa
																</div>}
														</div>
														<div style={{
															display: 'flex',
															flexDirection: 'column',
															justifyContent: 'center',
															alignItems: 'flex-start',
															fontSize: 12,
															flex: 1,
															minWidth: 0
														}}>

															<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																<div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
																	<i class='fas fa-user' style={{ marginRight: 4 }}></i>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}>{item.nome_motorista}</div>
																</div>
																<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '10%' }}>
																	{(usuarioOficina && (
																		item.ordem_servico_cavalo
																		|| item.ordem_servico_carreta1
																		|| item.ordem_servico_carreta2
																	)) &&
																	<div
																		style={{
																			marginRight: 4,
																			fontWeight: 'bold',
																			border: '1px solid #000',
																			borderRadius: 12,
																			padding: '1px',
																			fontSize: 8
																		}}
																	>
																		OS
																	</div>}
																	{(item.id_usuarios_impressao || []).includes(this.props.sessao.id) &&
																	<i class='fas fa-print' style={{ marginRight: 4 }}></i>}
																</div>
															</div>

															<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
																
															</div>
															{status.id == 1 && //Aguardando Entrada
																<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
																	<div style={{ display: 'flex', alignItems: 'center' }}>
																		<i class='fas fa-calendar-check' style={{ marginRight: 4 }}></i>
																		<div style={{}}><b>Prev. Chegada:</b></div>
																		<div style={{}}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada)}</div>
																	</div>
																	{/*status.id == 3 && //Aguardando Saída
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'row',
																			alignItems: 'center',
																			flex: 1,
																			width: '50%',
																			color: item.saida_atrasada ? '#b80300' : null
																		}}>
																		<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>{item.saida_atrasada ? 'Saída em atraso:' : 'Saída em:'}</b></div>
																	</div>*/}
																</div>}
															{/*<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																	{status.id == 1 && //Aguardando Entrada
																	<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																		<i class='fas fa-calendar-check' style={{ marginRight: 4 }}></i>
																		<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada)}</div>
																	</div>}
																	{status.id == 3 && //Aguardando Saída
																	<div
																		style={{
																			display: 'flex',
																			flexDirection: 'row',
																			alignItems: 'center',
																			width: '50%',
																			color: item.saida_atrasada ? '#b80300' : null
																		}}>
																		<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}>{item.dias_para_saida}</div>
																	</div>}
																</div>*/}

															{status.id == 1 && //Aguardando Entrada
																<div 
																	style={{
																		display: 'flex', 
																		alignItems: 'center', 
																		width: '100%', 
																		color: item.localizacao == 'Ijuí - RS' ? '#b80300' : '', 
																		fontWeight: item.localizacao == 'Ijuí - RS' ? 'bold' : ''  
																	}}>
																	<i class='fas fa-map-marker-alt' style={{ marginRight: 4 }}></i>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}>{item.localizacao}</div>
																</div>}

															{/* !this.props.filtro.compacto && */}
																<>
																	<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>SC:</b> {item.shipping_saida}</div>
																		</div>
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Cliente:</b> {item.cliente_saida}</div>
																		</div>
																	</div>
																	<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Rumo:</b> {item.rumo_saida}</div>
																		</div>
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			{item.rumo_saida == 'RS' &&
																				<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Fronteira:</b> {item.fronteira_saida}</div>}
																			{item.rumo_saida != 'RS' &&
																				<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Destino:</b> {item.destino_saida}</div>}
																		</div>
																	</div>
																	{(item.id_status == 2 || item.id_status == 3) &&
																	<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>No Pátio:</b> {DateFormat.formatarMinutosParaTempo(item.minutos_patio)}</div>
																		</div>
																		{item.id_status == 3 &&
																		<div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
																			<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Liberado:</b> {DateFormat.formatarMinutosParaTempo(item.minutos_liberado_setores)}</div>
																		</div>}
																	</div>}
																</>
															{/* } */}
															{/* {this.props.filtro.compacto && */}
																<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
																	<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Cliente:</b> {item.cliente_saida}</div>
																</div>
															{/* } */}

															{this.montarBadges(item, 'left')}
															
														</div>
													</div>
												</td>
											</tr>
										))}
									</TBody>
								</Table>
							</div>
							<div
								style={{
									borderTop: '4px solid #1F3066',
									width: '100%',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center'
								}}
							>
								<div>
									{status.id == 1 && //Aguardando Entrada
									<div style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class={`filter-chip ${this.props.filtro.passa_na_matriz ? 'active' : ''}`}
											style={{ width: 56, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginLeft: 0, marginRight: 0 }}
											title='Passa pela Matriz'
											onClick={() => {
												this.setFiltroCache({
													...this.props.filtro,
													passa_na_matriz: !this.props.filtro.passa_na_matriz,
													deslocamento_patio: false,
													reingresso: false,
													todos_aguardando_entrada: false
												});
											}}>
											P.Matriz
										</div>
										<div class={`filter-chip ${this.props.filtro.deslocamento_patio ? 'active' : ''}`}
											style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
											title={`Em deslocamento para a matriz \n- RN: Liberação da Fronteira \n- RS: Saída do Local de Coleta \n- NAC: Saída do Local de Coleta`}
											onClick={() => {
												this.setFiltroCache({
													...this.props.filtro,
													passa_na_matriz: false,
													deslocamento_patio: !this.props.filtro.deslocamento_patio,
													reingresso: false,
													todos_aguardando_entrada: false
												});
											}}>
											Desloc.
										</div>
										{/*<div class={`filter-chip ${this.props.filtro.reingresso ? 'active' : ''}`}
											style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
											title={`Reingresso`}
											onClick={() => {
												this.setFiltroCache({
													...this.props.filtro,
													passa_na_matriz: false,
													deslocamento_patio: false,
													reingresso: !this.props.filtro.reingresso
												});
											}}>
											Reingr.
										</div>*/}
										<div class={`filter-chip ${this.props.filtro.todos_aguardando_entrada ? 'active' : ''}`}
											style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
											title={`Todos`}
											onClick={() => {
												this.setFiltroCache({
													...this.props.filtro,
													passa_na_matriz: false,
													deslocamento_patio: false,
													reingresso: false,
													todos_aguardando_entrada: !this.props.filtro.todos_aguardando_entrada
												});
											}}>
											Todos
										</div>
									</div>}
								</div>

								<div
									style={{
										width: 80,
										backgroundColor: '#1F3066',
										textAlign: 'center',
										fontSize: 12,
										marginTop: 2,
										marginBottom: 2,
										fontWeight: 'bold',
										color: '#ffffff',
										padding: '6px 10px',
										borderRadius: 6,
										boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
										/* cria o recuo no canto superior esquerdo */
										clipPath: 'polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px)'
									}}
								>
									{/*this.getTextLabelRegistros(
										lista.filter(item => item.id_status == status.id).length
									)*/}
									{lista.filter(item => item.id_status == status.id).length ? lista.filter(item => item.id_status == status.id).length : '-'}
								</div>
							</div>
						</Grid>
					)
				})}
			</Row>
		);
	}

	lista(lista, heightTela) {

		const compacto = this.props.filtro.compacto;

		return (
			<>
				<div style={{ height: heightTela }}>
					<Table responsive border striped alturaFixa scroolHorizontal
						maxHeight={heightTela}>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>

								<ThSort
									field='id'
									label='Num.'
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_status'
									label='Status'
									width={120}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='cavalo'
									label='Cavalo'
									width={80}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='carreta1'
									label='Carreta 1'
									width={80}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='carreta2'
									label='Carreta 2'
									width={80}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_motorista'
									label='Motorista'
									width={220}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='datahora_previsao_chegada'
									label='Prev. Chegada'
									width={110}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='datahora_entrada'
									label='Entrada'
									width={110}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='datahora_previsao_saida'
									label='Prev. Saída'
									width={110}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='lote_crt_saida'
									label={<i class='fas fa-boxes' style={{ marginRight: 4 }}></i>}
									title={'Lote'}
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='carga_classificada_saida'
									label={<i class='fas fa-exclamation-triangle' style={{ marginRight: 4 }}></i>}
									title='Classificada'
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='expresso_saida'
									label={<i class='fas fa-shipping-fast' style={{ marginRight: 4 }}></i>}
									title='Expressa'
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='localizacao'
									label='Localização'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='shipping_saida'
									label='SC'
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='cliente_saida'
									label='Cliente'
									width={150}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='rumo_saida'
									label='Rumo'
									width={50}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='fronteira_saida'
									label='Fronteira'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='destino_saida'
									label='Destino'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='minutos_patio'
									label='No Pátio'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='minutos_liberado_setores'
									label='Liberado'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='fichas'
									label='Fichas'
									width={300}
									sticky />

								<ThSort
									field='id_usuarios_impressao'
									label={<i class='fas fa-print' style={{ marginRight: 4 }}></i>}
									width={10}
									sticky />

								<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={80} alignCenter>
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<button
											type='button'
											class='btn btn-flat btn-xs btn-success'
											title='Exportar'
											style={{
												visibility: 'visible',
												width: 24,
												height: 24,
												borderRadius: 4,
												border: 'none',
												background: 'linear-gradient(135deg, #16a34a, #22c55e)',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												cursor: 'pointer',
												boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
												transition: 'all 0.2s ease'
											}}
											onMouseEnter={e => {
												e.currentTarget.style.transform = 'scale(1.08)';
												e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.25)';
											}}
											onMouseLeave={e => {
												e.currentTarget.style.transform = 'scale(1)';
												e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
											}}
											onClick={() => {
												this.gerarExcel(lista.filter(item => [1, 2, 3].includes(item.id_status)));
											}}>
											<i class='fas fa-file-excel'></i>
										</button>

										<button
											type='button'
											class='btn btn-flat btn-xs btn-success'
											title='Gerar Ficha'
											style={{
												visibility: 'visible',
												marginLeft: 8,
												width: 24,
												height: 24,
												borderRadius: 4,
												border: 'none',
												background: 'linear-gradient(135deg, #007bff, #045fc1ff)',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												cursor: 'pointer',
												boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
												transition: 'all 0.2s ease'
											}}
											onMouseEnter={e => {
												e.currentTarget.style.transform = 'scale(1.08)';
												e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.25)';
											}}
											onMouseLeave={e => {
												e.currentTarget.style.transform = 'scale(1)';
												e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
											}}
											onClick={() => {
												this.setState({
													confirmacao: {
														mensagem: 'Deseja realmente imprimir?',
														eventoSim: () => {
															this.props.gerarPdfFicha(lista.filter(item => [2, 3].includes(item.id_status)));
															this.setState({
																confirmacao: null
															});
														},
														eventoCancelar: () => {
															this.setState({
																confirmacao: null
															});
														}
													}
												});
											}}>
											<i class='fas fa-file-pdf'></i>
										</button>
									</div>
								</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.filter(item => this.state.statusVisiveis.includes(item.id_status)).map((item, i) => {
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{item.id}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
										<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.nome_motorista}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)}</Td>
										<Td 
											backgroundColor={this.state.linhaSelecionada != item.id && item.atraso == 'atrasado' ? '#fac5c5' : ''} 
											color={item.atraso == 'atrasado' ? '#b80300' : '#000'} 
											bold={item.atraso == 'atrasado'} 
											alignCenter 
											small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</Td>
										<Td color={'#000'} alignCenter small noWrap title={item.lote_crt_saida || ''}>
											{item.lote_crt_saida &&
											<i class='fas fa-boxes' style={{ marginRight: 4 }}></i>}
										</Td>
										<Td color={'#000'} alignCenter small noWrap title='Classificada'>
											{item.carga_classificada_saida &&
											<i class='fas fa-exclamation-triangle' style={{ marginRight: 4 }}></i>}
										</Td>
										<Td color={'#000'} alignCenter small noWrap title='Expressa'>
											{item.expresso_saida &&
											<i class='fas fa-shipping-fast' style={{ marginRight: 4 }}></i>}
										</Td>
										<Td 
											color={item.localizacao == 'Ijuí - RS' ? '#b80300' : '#000'} 
											bold={item.localizacao == 'Ijuí - RS'} 
											alignCenter
											small
											noWrap={compacto}>{item.localizacao}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.shipping_saida}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.cliente_saida}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.rumo_saida}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.fronteira_saida}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>{item.destino_saida}</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>
											{item.id_status == 2 || item.id_status == 3 ? DateFormat.formatarMinutosParaTempo(item.minutos_patio) : ''}
										</Td>
										<Td color={'#000'} alignCenter small noWrap={compacto}>
											{item.id_status == 3 ? DateFormat.formatarMinutosParaTempo(item.minutos_liberado_setores) : ''}
										</Td>

										<Td color={'#000'} alignCenter small noWrap>
											{this.montarBadges(item, 'center')}
										</Td>
										<Td color={'#000'} alignCenter small noWrap>
											{(item.id_usuarios_impressao || []).includes(this.props.sessao.id) &&
											<i class='fas fa-print' style={{ marginRight: 4 }}></i>}
										</Td>
										<Td minWidth={10} width={10} alignCenter>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												small
												event={() => {
													this.clickCardLista(item);
												}} />
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</div>

				{/*<div
					style={{
						backgroundColor: '#1F3066',
						padding: 2,
						paddingRight: 18,
						width: '100%',
						display: 'flex',
						justifyContent: 'flex-end',
						alignItems: 'center'
					}}
				>
					<div
						style={{
							width: 140,
							backgroundColor: '#ffffff',
							textAlign: 'center',
							fontSize: 11,
							fontWeight: 'bold',
							color: '#1F3066',
							padding: '6px 10px',
							borderRadius: 6,
							boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
							clipPath: 'polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px)'
						}}
					>
						{this.getTextLabelRegistros(
							lista.length
						)}
					</div>
				</div>*/}
				<div
					style={{
						borderTop: '4px solid #1F3066',
						width: '100%',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center'
					}}
				>
					<div>
						{this.state.statusVisiveis.includes(1) && //Apenas se tem aguardando entrada
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div class={`filter-chip ${this.props.filtro.passa_na_matriz ? 'active' : ''}`}
								style={{ width: 56, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginLeft: 0, marginRight: 0 }}
								title='Passa pela Matriz'
								onClick={() => {
									this.setFiltroCache({
										...this.props.filtro,
										passa_na_matriz: !this.props.filtro.passa_na_matriz,
										deslocamento_patio: false,
										reingresso: false,
										todos_aguardando_entrada: false
									});
								}}>
								P.Matriz
							</div>
							<div class={`filter-chip ${this.props.filtro.deslocamento_patio ? 'active' : ''}`}
								style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
								title={`Em deslocamento para a matriz \n- RN: Liberação da Fronteira \n- RS: Saída do Local de Coleta \n- NAC: Saída do Local de Coleta`}
								onClick={() => {
									this.setFiltroCache({
										...this.props.filtro,
										passa_na_matriz: false,
										deslocamento_patio: !this.props.filtro.deslocamento_patio,
										reingresso: false,
										todos_aguardando_entrada: false
									});
								}}>
								Desloc.
							</div>
							{/*<div class={`filter-chip ${this.props.filtro.reingresso ? 'active' : ''}`}
								style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
								title={`Reingresso`}
								onClick={() => {
									this.setFiltroCache({
										...this.props.filtro,
										passa_na_matriz: false,
										deslocamento_patio: false,
										reingresso: !this.props.filtro.reingresso
									});
								}}>
								Reingr.
							</div>*/}
							<div class={`filter-chip ${this.props.filtro.todos_aguardando_entrada ? 'active' : ''}`}
								style={{ width: 55, fontSize: 10, marginBottom: 1, marginTop: 0, justifyContent: 'center', marginRight: 0 }}
								title={`Todos`}
								onClick={() => {
									this.setFiltroCache({
										...this.props.filtro,
										passa_na_matriz: false,
										deslocamento_patio: false,
										reingresso: false,
										todos_aguardando_entrada: !this.props.filtro.todos_aguardando_entrada
									});
								}}>
								Todos
							</div>
						</div>}
					</div>

					<div
						style={{
							width: 80,
							backgroundColor: '#1F3066',
							textAlign: 'center',
							fontSize: 12,
							marginTop: 2,
							marginBottom: 2,
							fontWeight: 'bold',
							color: '#ffffff',
							padding: '6px 10px',
							borderRadius: 6,
							boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
							/* cria o recuo no canto superior esquerdo */
							clipPath: 'polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px)'
						}}
					>
						{/*this.getTextLabelRegistros(
						lista.filter(item => item.id_status == status.id).length
						)*/}
						{lista.filter(item => this.state.statusVisiveis.includes(item.id_status)).length ? lista.filter(item => this.state.statusVisiveis.includes(item.id_status)).length : '-'}
					</div>
				</div>
			</>

		);
	}

	setFichas(registro) {
		this.setState({
			registroFichas: registro
		});
	}

	registroFicha() {

		if (!this.state.registroFichas) {
			return;
		}

		const registro = this.state.registroFichas;

		const possuiManutencao = registro.listaManutencoes.filter(manutencao => manutencao.id_setor == registro.id_setor).length > 0;

		return (
			<>
				<div className="modal-backdrop fade show"
					onClick={() => this.setFichas(null)} />
				<div class='modal fade show'
					onClick={() => this.setFichas(null)}
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'
						onClick={(e) => e.stopPropagation()}>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>{registro.cavalo} - {registro.nome}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setFichas(null)}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<Row>
									<Grid cols='12 12 12 12'>
										{registro.listaFichas &&
											<Table responsive border striped>
												<THead>
													<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
														<ThSort field='setor' label='Setor' width={100} sticky />
														<ThSort field='nome' label='Nome' width={100} sticky />
														{possuiManutencao &&
															<ThSort field='listaManutencoes' label='Itens' width={100} sticky />}
														<ThSort field='status' label='Status' width={100} sticky />
														<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
														<ThSort field='lista_eventos' label='Histórico' width={10} sticky />
													</Tr>
												</THead>
												<TBody>
													{registro.listaFichas.map((item, i) => {
														return (
															<Tr key={item.id}
																backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
																onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
																<Td color={'#000'} alignCenter>
																	<i class={registro.icone} style={{ marginRight: 4 }}></i>
																	{registro.nome}
																</Td>
																<Td color={'#000'} alignCenter>{item.nome}</Td>
																{possuiManutencao &&
																	<Td color={'#000'} alignCenter>
																		<div>
																			{registro.listaManutencoes.filter(manutencao => manutencao.id_controle_patio_ficha == item.id_controle_patio_ficha).map((manutencao, pos) => (
																				<div key={pos} style={{ fontSize: 13, display: 'flex', alignItems: 'center' }}>

																					<label
																						key={pos}
																						style={{
																							fontSize: 16,
																							display: 'flex',
																							alignItems: 'center',
																							padding: '8px 4px',
																							cursor: 'pointer',
																							userSelect: 'none'
																						}}
																						disabled={true}
																					>
																						<input
																							type='checkbox'
																							checked={!!manutencao.executado}
																							style={{
																								marginRight: 10,
																								width: 18,
																								height: 18,
																								cursor: 'pointer'
																							}}
																							disabled={true}
																						/>

																						<span
																							style={{
																								textDecoration: !manutencao.executado ? 'line-through' : 'none',
																								color: !manutencao.executado ? '#888' : '#000',
																								fontSize: 14
																							}}
																						>
																							{manutencao.descricao}
																						</span>
																					</label>

																				</div>
																			))}
																		</div>
																	</Td>}
																<Td color={'#000'} alignCenter>
																	{item.datahora_fim ? 'Finalizada' : (item.datahora_liberacao ? 'Liberada' : (item.datahora_inicio ? 'Iniciada' : 'Não Inciada'))}
																</Td>
																<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
																<Td color={'#000'} alignCenter>
																	<table style={{ width: '100%' }}>
																		<tbody>
																			{(item.lista_eventos || []).map(itemEvento => (
																				<tr key={itemEvento.id}>
																					<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_evento}</td>
																					<td width={100} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{DateFormat.formatarDataHoraSqlParaTela(itemEvento.datahora)}</td>
																					<td width={200} style={{ fontSize: 10, textAlign: 'center', verticalAlign: 'middle' }}>{itemEvento.nome_usuario}</td>
																				</tr>
																			))}
																		</tbody>
																	</table>
																</Td>
															</Tr>
														);
													})}
												</TBody>
											</Table>}

										{registro.listaPendencias &&
											<Table responsive border striped>
												<THead>
													<Tr backgroundColor={'#1F3066'} color={'#ffffff'} height={47}>
														<ThSort field='setor' label='Setor' width={100} sticky />
														<ThSort field='nome' label='Nome' width={100} sticky />
														<ThSort field='nome_status' label='Status' width={100} sticky />
														<ThSort field='nome_tipo' label='Pendência' width={100} sticky />
														<ThSort field='observacao' label='Observação' width={100} sticky />
														<ThSort field='obrigatoria' label='Obrigatória' width={10} sticky />
														<ThSort field='data_maxima' label='Data Máxima' width={100} sticky />
													</Tr>
												</THead>
												<TBody>
													{registro.listaPendencias.map((item, i) => {
														return (
															<Tr key={item.id}
																backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
																onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
																<Td color={'#000'} alignCenter>
																	<i class={registro.icone} style={{ marginRight: 4 }}></i>
																	{item.nome_setor}
																</Td>
																<Td color={'#000'} alignCenter>{item.nome}</Td>
																<Td color={'#000'} alignCenter>{item.nome_status}</Td>
																<Td color={'#000'} alignCenter>{item.nome_tipo}</Td>
																<Td color={'#000'} alignCenter>{item.observacao}</Td>
																<Td color={'#000'} alignCenter>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
																<Td color={'#000'} alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_maxima)}</Td>
															</Tr>
														);
													})}
												</TBody>
											</Table>}
									</Grid>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}
	
	gerarExcel(listaFiltrada) {

		Excel.exportar('Controle de Pátio',
			[{
				atributo: 'id',
				nome: 'Número Controle',
				largura: 15,
				formato: null
			}, {
				atributo: 'cavalo',
				nome: 'Cavalo',
				largura: 15,
				formato: null
			}, {
				atributo: 'carreta1',
				nome: 'Carreta 1',
				largura: 15,
				formato: null
			}, {
				atributo: 'carreta2',
				nome: 'Carreta 2',
				largura: 15,
				formato: null
			}, {
				atributo: 'nome_motorista',
				nome: 'Motorista',
				largura: 40,
				formato: null
			}, {
				atributo: 'nome_status',
				nome: 'Status',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_criacao',
				nome: 'Criação',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_previsao_entrada',
				nome: 'Previsão Entrada',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_previsao_saida',
				nome: 'Previsão Saída',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_entrada',
				nome: 'Entrada',
				largura: 18,
				formato: null
			}, {
				atributo: 'observacao_entrada',
				nome: 'Observação Entrada',
				largura: 50,
				formato: null
			}, {
				atributo: 'shipping_saida',
				nome: 'Shipping',
				largura: 15,
				formato: null
			}, {
				atributo: 'rumo_saida',
				nome: 'Rumo',
				largura: 10,
				formato: null
			}, {
				atributo: 'cliente_saida',
				nome: 'Cliente',
				largura: 30,
				formato: null
			}, {
				atributo: 'fronteira_saida',
				nome: 'Fronteira',
				largura: 30,
				formato: null
			}, {
				atributo: 'destino_saida',
				nome: 'Destino',
				largura: 30,
				formato: null
			}, {
				atributo: 'minutos_patio',
				nome: 'No Pátio',
				largura: 30,
				formato: null
			}, {
				atributo: 'minutos_liberado_setores',
				nome: 'Liberado',
				largura: 30,
				formato: null
			}, {
				atributo: 'lote_crt_saida',
				nome: 'Lote',
				largura: 20,
				formato: null
			}, {
				atributo: 'carga_classificada_saida',
				nome: 'Classificada',
				largura: 15,
				formato: null
			}, {
				atributo: 'expresso_saida',
				nome: 'Expressa',
				largura: 15,
				formato: null
			}, {
				atributo: 'nome_usuario_entrada',
				nome: 'Usuário Entrada',
				largura: 20,
				formato: null
			}, {
				atributo: 'localizacao',
				nome: 'Localização',
				largura: 30,
				formato: null
			}, {
				atributo: 'odometro_entrada',
				nome: 'Odômetro Entrada',
				largura: 15,
				formato: null
			}, {
				atributo: 'ordem_servico_cavalo',
				nome: 'OS Cavalo',
				largura: 15,
				formato: null
			}, {
				atributo: 'ordem_servico_carreta1',
				nome: 'OS Carreta 1',
				largura: 15,
				formato: null
			}, {
				atributo: 'ordem_servico_carreta2',
				nome: 'OS Carreta 2',
				largura: 15,
				formato: null
			}
		],
			listaFiltrada.map(item => ({
				...item,
				minutos_patio: DateFormat.formatarMinutosParaTempo(item.minutos_patio),
				minutos_liberado_setores: DateFormat.formatarMinutosParaTempo(item.minutos_liberado_setores),
				datahora_criacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_criacao),
				datahora_previsao_entrada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada),
				datahora_previsao_saida: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida),
				datahora_entrada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)
			}))
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTela,
	lista: state.controlePatio.lista,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus,
	listaRumo: state.controlePatio.listaRumo,
	listaAtraso: state.controlePatio.listaAtraso,
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getLista,
	getListaMotorista, getListaPlaca, getListaSetor, getListaLogs, gerarPdfFicha
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatio);
